import Fondo from "../assets/people.png";
import { motion } from "framer-motion";

const QuienesSomos = () => {
    return (
        <div className="relative w-full h-auto md:h-[80vh] grid grid-cols-1 md:grid-cols-2">
            <motion.div
                initial={{ opacity: 0, x: -100 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 1.5, ease: "easeOut" }}
                viewport={{ once: true, amount: 0.3 }}
                className="w-full h-[55vh] md:h-full bg-cover bg-top bg-no-repeat flex items-center justify-start"
                style={{ backgroundImage: `url(${Fondo})` }}
            />
            <motion.div
                className="w-full h-full flex flex-col justify-center text-left bg-[#00245D] px-4 md:px-10 gap-4 text-white"
                initial={{ opacity: 0, x: 100 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 1.5, ease: "easeOut" }}
                viewport={{ once: true, amount: 0.3 }}
            >
                <p>ESTAMOS A SU ENTERA DISPOSICIÓN</p>
                <h1 className="font-bold text-6xl">Identifique sus objetivos y alcáncelos</h1>
                <p className="text-lg text-justify">
                    Después de ayudarlo a descubrir lo que quiere, trabajaremos juntos para encontrar la mejor manera de conseguirlo.
                </p>
            </motion.div>
            <div className="absolute bottom-0 left-0 w-full overflow-hidden z-40">
                <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 1920 323.84"
                preserveAspectRatio="none"
                className="w-full h-32"
                >
                <path
                    d="M1920,327.44V0S1493.72,241.15,989.28,130.25C71-71.64,0,327.44,0,327.44Z"
                    fill="white"
                />
                </svg>
            </div>
        </div>
    );
};
export default QuienesSomos;